export const errorCode: any = {
  401: '认证失败，无法访问系统资源',
  403: '当前操作没有权限',
  1004: '当前账号无权执行此操作，请联系管理员',
  404: '访问资源不存在',
  default: '请求处理失败，请稍后重试',
};
export default errorCode;
